import script from "./RecurringPayments.vue?vue&type=script&setup=true&lang=js"
export * from "./RecurringPayments.vue?vue&type=script&setup=true&lang=js"

import "./RecurringPayments.vue?vue&type=style&index=0&id=68dea5b7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68dea5b7"]])

export default __exports__